// @flow

import { type LookAndFeel } from '@tectonics/look-and-feel';
import { LOOK_AND_FEELS, DEFAULT_LOOK_AND_FEEL } from './look-and-feels';
import { getInitialLookAndFeelCode } from './laf-chooser';
import { type IncomingPayment, getMerchant } from '@tectonics/prs/incoming-payment';
import { getLookAndFeel } from '@tectonics/prs/merchant';

export function getLookAndFeelFromEnvironment(incomingPayment: IncomingPayment, forcedCode: ?string): LookAndFeel {
  const merchant = getMerchant(incomingPayment);

  function production(): LookAndFeel {
    const code = forcedCode || getLookAndFeel(getMerchant(incomingPayment));
    return LOOK_AND_FEELS.find(laf => code === laf.code) || DEFAULT_LOOK_AND_FEEL;
  }

  function test(): LookAndFeel {
    const search = /payment-sandbox-(\w+)\./.exec(location.hostname);
    const code = forcedCode || getInitialLookAndFeelCode() || (search && search[1]) || getLookAndFeel(merchant);
    return LOOK_AND_FEELS.find(laf => code === laf.code) || DEFAULT_LOOK_AND_FEEL;
  }

  function sandbox(): LookAndFeel {
    const code = forcedCode || getInitialLookAndFeelCode() || getLookAndFeel(merchant);
    return LOOK_AND_FEELS.find(laf => code === laf.code) || DEFAULT_LOOK_AND_FEEL;
  }

  function development(): LookAndFeel {
    const code = forcedCode || getInitialLookAndFeelCode() || getLookAndFeel(merchant);
    return LOOK_AND_FEELS.find(laf => code === laf.code) || DEFAULT_LOOK_AND_FEEL;
  }

  return { production, development, test, sandbox }[ENV_CONSTANTS.ENV]();
}
